<template>
  <button type="button" class="gs-transaction-date" :aria-label="fullDate"
    v-tooltip="{ content: fullDate, classes: 'gs-transaction-tooltip', html: false, trigger: 'hover focus click', delay: { show: 500, hide: 0 } }" @click.stop>
    {{ date }}
  </button>
</template>
<script>
import { compactTransactionDate } from '@/helpers/transactionTableStatus';
export default {
  computed: {
    date() { return compactTransactionDate(this.params.data); },
    fullDate() { return this.params.data?.formatted_date_time || this.date; },
  },
};
</script>
